import { render } from "./CommunityTalkNewArrivalBadge.vue?vue&type=template&id=3d2cb382&scoped=true&ts=true"
import script from "./CommunityTalkNewArrivalBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommunityTalkNewArrivalBadge.vue?vue&type=script&setup=true&lang=ts"

import "./CommunityTalkNewArrivalBadge.vue?vue&type=style&index=0&id=3d2cb382&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d2cb382"],['__file',"src/components/communityTalk/CommunityTalkNewArrivalBadge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d2cb382"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d2cb382', __exports__)) {
    api.reload('3d2cb382', __exports__)
  }
  
  module.hot.accept("./CommunityTalkNewArrivalBadge.vue?vue&type=template&id=3d2cb382&scoped=true&ts=true", () => {
    api.rerender('3d2cb382', render)
  })

}


export default __exports__